import emailjs from '@emailjs/browser';
import { ContactFormData } from '../types/form';

export const sendContactEmail = async (formData: ContactFormData): Promise<void> => {
  try {
    await emailjs.init(import.meta.env.VITE_EMAILJS_PUBLIC_KEY);
    
    await emailjs.send(
      import.meta.env.VITE_EMAILJS_SERVICE_ID,
      import.meta.env.VITE_EMAILJS_TEMPLATE_ID,
      {
        from_name: `${formData.firstName} ${formData.lastName}`,
        from_email: formData.email,
        phone: formData.phone,
        project_type: formData.projectType,
        message: formData.message
      }
    );
  } catch (error) {
    console.error('Erreur envoi email:', error);
    throw new Error('Échec envoi email');
  }
};